/**
 * Conditions d'utilisation — FR (fait foi).
 * Version validée juridiquement par le client (Phase 12+).
 */
export const termsFr = {
  eyebrow: "Documents légaux",
  title: "Conditions d'utilisation",
  subtitle:
    "Les présentes Conditions Générales d'Utilisation (CGU) régissent l'accès et l'utilisation du site openmeta.tech et des services associés proposés par OPENMETA. En créant un compte ou en utilisant les services, l'utilisateur accepte ces conditions sans réserve.",
  updated: '8 septembre 2026',
  seoTitle: "Conditions d'utilisation — OpenMeta",
  seoDescription:
    "Conditions générales d'utilisation d'OpenMeta : comptes créateurs, abonnements Basique et Pro, publication d'applications no-code, modération, propriété intellectuelle, droit français.",
  sections: [
    {
      id: 'editeur',
      title: 'Éditeur',
      blocks: [
        {
          type: 'p',
          content:
            "Le site openmeta.tech (ci-après « OpenMeta » ou « le Service ») est édité par OPENMETA, société par actions simplifiée au capital de 40 000 €, immatriculée au Registre du commerce et des sociétés d'Alençon sous le numéro 978 390 813, dont le siège social est situé 5037 Chemin de la Veillotière, 61330 Ceaucé, France.",
        },
        {
          type: 'p',
          content:
            "Numéro d'identification européen : FR6101.978390813.\nContact : support@openmeta.fr\nTéléphone : +33 2 59 16 64 45",
        },
      ],
    },
    {
      id: 'objet',
      title: 'Objet du Service',
      blocks: [
        {
          type: 'p',
          content:
            "OpenMeta est une plateforme no-code et d'intelligence artificielle qui permet aux utilisateurs de :",
        },
        {
          type: 'ul',
          content: [
            "Générer des concepts d'applications à partir d'une description libre (« le Générateur »).",
            "Explorer des maquettes interactives illustrant ces concepts (« le Prototype »).",
            "Assembler et publier de véritables mini-applications à partir de blocs configurables : page contenu, chatbot IA et formulaire (« le Constructeur »).",
            "Héberger et diffuser les applications publiées sur des URL publiques dédiées.",
          ],
        },
        {
          type: 'p',
          content:
            "OpenMeta est un outil de création : l'utilisateur est libre du contenu qu'il génère et publie, sous réserve du respect des présentes CGU, de la loi et des droits des tiers.",
        },
      ],
    },
    {
      id: 'comptes',
      title: 'Comptes utilisateurs',
      blocks: [
        {
          type: 'p',
          content:
            "L'accès à l'espace créateur nécessite la création d'un compte au moyen d'une adresse email valide et d'un mot de passe d'au moins 8 caractères. L'utilisateur déclare avoir au moins 18 ans et être juridiquement capable de contracter.",
        },
        {
          type: 'p',
          content:
            "L'utilisateur est seul responsable de la confidentialité de ses identifiants et de toute activité effectuée depuis son compte. Toute utilisation suspecte doit être signalée sans délai à support@openmeta.fr.",
        },
        {
          type: 'p',
          content:
            "OPENMETA se réserve le droit de suspendre ou de supprimer tout compte en cas de violation des présentes CGU, sans que cela n'ouvre droit à indemnisation.",
        },
      ],
    },
    {
      id: 'abonnements',
      title: 'Abonnements et paiement',
      blocks: [
        {
          type: 'p',
          content:
            "Les fonctionnalités de publication du Service nécessitent un abonnement actif. Deux plans sont proposés :",
        },
        {
          type: 'ul',
          content: [
            "Plan Basique : 29 € HT par mois, 1 application publiée simultanément, brouillons illimités.",
            "Plan Pro : 290 € HT par mois, jusqu'à 10 applications publiées simultanément, brouillons illimités, priorité de support.",
          ],
        },
        {
          type: 'p',
          content:
            "Une facturation annuelle est disponible avec une remise de 20 % sur le tarif mensuel équivalent. Les prix sont indiqués hors taxes ; la TVA applicable est ajoutée le cas échéant selon la législation en vigueur.",
        },
        {
          type: 'p',
          content:
            "Les paiements sont traités par Stripe, prestataire spécialisé dans le paiement en ligne. OPENMETA ne reçoit jamais le numéro complet de la carte bancaire. Les mensualités et abonnements annuels se renouvellent tacitement à l'échéance. La résiliation peut être effectuée à tout moment depuis l'espace créateur ou par email à support@openmeta.fr ; elle prend effet à la fin de la période en cours, sans remboursement au prorata.",
        },
        {
          type: 'p',
          content:
            "Conformément à l'article L.221-28 du Code de la consommation, l'utilisateur qui accepte l'exécution immédiate du Service reconnaît renoncer à son droit de rétractation pour les prestations pleinement exécutées avant la fin du délai de rétractation.",
        },
      ],
    },
    {
      id: 'contenu-createur',
      title: 'Contenu créateur et licence',
      blocks: [
        {
          type: 'p',
          content:
            "L'utilisateur reste propriétaire du contenu qu'il crée, saisit et publie via OpenMeta (« le Contenu Créateur »). En le publiant sur openmeta.tech/app/… ou en le partageant via le Service, l'utilisateur accorde à OPENMETA une licence non exclusive, mondiale, gratuite et limitée à l'hébergement, l'affichage, la reproduction technique et la diffusion strictement nécessaires au fonctionnement du Service.",
        },
        {
          type: 'p',
          content:
            "L'utilisateur garantit qu'il dispose de tous les droits nécessaires sur le Contenu Créateur qu'il publie, qu'il ne porte pas atteinte aux droits des tiers (droit d'auteur, marque, vie privée, image) et qu'il respecte la législation applicable.",
        },
        {
          type: 'p',
          content: 'Sont notamment interdits, sans que cette liste soit limitative :',
        },
        {
          type: 'ul',
          content: [
            "Les contenus illicites, contrefaisants, diffamatoires, injurieux, discriminatoires ou incitant à la haine ou à la violence.",
            "Les contenus trompeurs, frauduleux, ou constituant du phishing, du spam ou de la manipulation.",
            "Les contenus à caractère médical, juridique, financier ou fiscal donnant l'impression de constituer un conseil professionnel personnalisé, sans mention claire indiquant qu'il ne s'agit pas d'un tel conseil.",
            "Les contenus pornographiques, violents ou inappropriés pour un public non averti.",
            "Les contenus impliquant la collecte de données personnelles sans base légale ou sans information des personnes concernées.",
          ],
        },
      ],
    },
    {
      id: 'moderation',
      title: 'Modération',
      blocks: [
        {
          type: 'p',
          content:
            "OPENMETA se réserve le droit, à tout moment et sans préavis, de dépublier, suspendre ou supprimer toute application ou tout contenu qui contreviendrait aux présentes CGU, à la loi, aux droits des tiers ou à l'intérêt légitime du Service.",
        },
        {
          type: 'p',
          content:
            "En cas de modération, l'application concernée passe automatiquement en état « brouillon » et sa publication est bloquée jusqu'à la levée du drapeau par un administrateur. La raison de la modération est visible par le créateur dans son espace studio.",
        },
        {
          type: 'p',
          content:
            "L'utilisateur peut à tout moment contester une décision de modération en écrivant à support@openmeta.fr.",
        },
      ],
    },
    {
      id: 'ia',
      title: 'Fonctions assistées par intelligence artificielle',
      blocks: [
        {
          type: 'p',
          content:
            "OpenMeta propose des fonctions génératives (génération de concepts, prototypes, chatbots) reposant sur des modèles d'intelligence artificielle tiers. Les résultats produits sont fournis à titre indicatif et peuvent contenir des erreurs, approximations ou biais.",
        },
        {
          type: 'note',
          content:
            "Les fonctions d'intelligence artificielle d'OpenMeta ne constituent en aucun cas un conseil médical, juridique, financier, comptable, fiscal ou professionnel personnalisé. Toute décision fondée sur ces résultats doit faire l'objet d'une vérification humaine par un professionnel qualifié.",
        },
        {
          type: 'p',
          content:
            "Le traitement des données transmises à ces prestataires est encadré par notre Politique de confidentialité (rubrique « Traitement par intelligence artificielle »).",
        },
      ],
    },
    {
      id: 'propriete',
      title: 'Propriété intellectuelle',
      blocks: [
        {
          type: 'p',
          content:
            "L'ensemble des éléments composant le Service (charte graphique, code, interfaces, logos, marques, textes, illustrations, sons) est la propriété exclusive d'OPENMETA ou de ses partenaires, et est protégé par le droit de la propriété intellectuelle.",
        },
        {
          type: 'p',
          content:
            "Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie du Service, par quelque procédé que ce soit, est strictement interdite sans autorisation écrite préalable d'OPENMETA.",
        },
        {
          type: 'p',
          content:
            "L'utilisation du Service ne confère à l'utilisateur aucun droit de propriété sur les éléments d'OpenMeta.",
        },
      ],
    },
    {
      id: 'disponibilite',
      title: 'Disponibilité et évolutions',
      blocks: [
        {
          type: 'p',
          content:
            "OPENMETA s'efforce de maintenir le Service accessible sans interruption, mais ne garantit pas une disponibilité continue. Le Service peut être temporairement interrompu pour maintenance, mise à jour, incident technique ou cas de force majeure.",
        },
        {
          type: 'p',
          content:
            "OPENMETA peut faire évoluer les fonctionnalités, les paramètres et les tarifs du Service, sous réserve d'un préavis raisonnable pour toute modification substantielle affectant un abonnement en cours.",
        },
      ],
    },
    {
      id: 'responsabilite',
      title: 'Limitation de responsabilité',
      blocks: [
        {
          type: 'p',
          content:
            "Dans les limites autorisées par la loi, OPENMETA ne saurait être tenue responsable des dommages indirects (perte de données, perte de chance, atteinte à la réputation, préjudice commercial) résultant de l'utilisation ou de l'impossibilité d'utiliser le Service.",
        },
        {
          type: 'p',
          content:
            "OPENMETA n'est pas responsable du Contenu Créateur publié par les utilisateurs ni des interactions entre utilisateurs et visiteurs des applications publiées.",
        },
        {
          type: 'p',
          content:
            "La responsabilité éventuelle d'OPENMETA, tous préjudices confondus, ne pourra excéder le montant HT effectivement payé par l'utilisateur au titre de son abonnement au cours des douze (12) mois précédant le fait générateur.",
        },
      ],
    },
    {
      id: 'donnees',
      title: 'Données personnelles',
      blocks: [
        {
          type: 'p',
          content:
            "Le traitement des données personnelles par OPENMETA est décrit dans la Politique de confidentialité, accessible à l'adresse /confidentialite. En créant un compte, l'utilisateur reconnaît en avoir pris connaissance.",
        },
        {
          type: 'p',
          content:
            "Les questions relatives aux données personnelles peuvent être adressées à support@openmeta.fr.",
        },
      ],
    },
    {
      id: 'droit',
      title: 'Droit applicable et juridiction',
      blocks: [
        {
          type: 'p',
          content:
            "Les présentes CGU sont régies par le droit français. À défaut de résolution amiable, tout litige relatif à leur interprétation ou à leur exécution sera porté devant les tribunaux compétents du ressort du siège social d'OPENMETA, sous réserve des dispositions impératives applicables aux consommateurs.",
        },
      ],
    },
    {
      id: 'contact',
      title: 'Contact',
      blocks: [
        {
          type: 'p',
          content:
            "OPENMETA\n5037 Chemin de la Veillotière\n61330 Ceaucé — France\nTél. +33 2 59 16 64 45\nE-mail : support@openmeta.fr",
        },
      ],
    },
  ],
};
